__turbopack_context__.v({
  "buttonStyle": "Uza5vq_buttonStyle",
  "errorReference": "Uza5vq_errorReference",
  "linkErrorInHeader": "Uza5vq_linkErrorInHeader",
  "note": "Uza5vq_note",
  "noteDivider": "Uza5vq_noteDivider",
  "subtitle": "Uza5vq_subtitle",
  "toggle": "Uza5vq_toggle",
  "wrapper": "Uza5vq_wrapper",
});
